<template>
  <div>
    <h2>
      <span
        v-if="icon"
        class="mr-2"
        :class="icon">
      </span>
      {{ title }}
    </h2>
  </div>
</template>
<script>
  export default {
    name: 'HeaderView',
    props: {
      icon: {
        type: String
      },
      title: {
        type: String,
        required: true
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/common/HeaderView.vue